'use strict';

function isPostedPayApp(pa) {
  const s = String(pa.status || '').toLowerCase();
  return s === 'submitted' || s === 'paid' || s === 'payment_received';
}

function payAppNumberLabel(appNumber) {
  if (appNumber == null || appNumber === '') return 'Draft';
  return String(appNumber);
}

function isEmptyAmount(amountDue) {
  if (amountDue == null || amountDue === '') return true;
  const amt = parseFloat(amountDue);
  return Number.isNaN(amt) || amt === 0;
}

function isWizardEmptyDraft(pa) {
  if (pa.status !== 'draft') return false;
  if (pa.period_label?.trim()) return false;
  if (!isEmptyAmount(pa.amount_due)) return false;
  if (pa.created_at) {
    const ageMs = Date.now() - new Date(pa.created_at).getTime();
    if (ageMs > 7 * 86_400_000) return false;
  }
  return true;
}

function sumDraftPayAppAmount(payApps) {
  return payApps
    .filter((pa) => pa.status === 'draft')
    .reduce((s, pa) => s + (parseFloat(pa.amount_due ?? '0') || 0), 0);
}

function liveDrafts(payApps) {
  return payApps.filter((pa) => pa.status === 'draft' && !pa.deleted_at);
}

function findContinueDraft(payApps) {
  const drafts = liveDrafts(payApps);
  if (!drafts.length) return null;
  return drafts.reduce((best, pa) => {
    const t = pa.created_at ? new Date(pa.created_at).getTime() : 0;
    const bt = best.created_at ? new Date(best.created_at).getTime() : 0;
    return t > bt ? pa : best;
  });
}

function nextPayAppDisplayNumber(payApps) {
  const nums = payApps
    .filter((pa) => !pa.deleted_at && isPostedPayApp(pa) && pa.app_number != null)
    .map((pa) => Number(pa.app_number) || 0);
  return nums.length ? Math.max(...nums) + 1 : 1;
}

export {
  isWizardEmptyDraft,
  sumDraftPayAppAmount,
  findContinueDraft,
  nextPayAppDisplayNumber,
  payAppNumberLabel,
  isPostedPayApp,
};
